module.exports = __webpack_public_path__ + "static/media/post-registrationM.07a20f1f.png";